// extracted by mini-css-extract-plugin
export default {"profileInfoRow":"distributor-profile_profileInfoRow__lxyA3"};